import {
  CreateDocumentSource,
  DeleteDocumentSourceArgs,
  DocumentSource,
  DocumentSourceConnector,
  DocumentSourceId,
  DocumentSourceMin,
  UpdateDocumentSource,
} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function listConnectors(): Promise<DocumentSourceConnector[]> {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/vendor_toolkit/document_source_connectors`,
    {},
  );
}

export async function getConnector(connectorId: string): Promise<DocumentSourceConnector> {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/vendor_toolkit/document_source_connectors/{document_source_connector_id}`,
    {path: {document_source_connector_id: connectorId}},
  );
}

export async function list(): Promise<DocumentSourceMin[]> {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/document_sources`, {});
}

export async function get(documentSourceId: DocumentSourceId): Promise<DocumentSource> {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/vendor_toolkit/document_sources/{document_source_id}`,
    {path: {document_source_id: documentSourceId}},
  );
}

export async function create(document: CreateDocumentSource): Promise<DocumentSource> {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/vendor_toolkit/document_sources`, {
    body: document,
  });
  await invalidateQueries([q.vendorToolkit.documentSources.filter()]);
  return res;
}

export async function delete_(documentSourceId: DocumentSourceId, args: DeleteDocumentSourceArgs): Promise<string> {
  const res = await platformedClient.internalRequest(
    "delete",
    `/region/{region}/api/vendor_toolkit/document_sources/{document_source_id}`,
    {query: args, path: {document_source_id: documentSourceId}},
  );
  await invalidateQueries([
    q.vendorToolkit.documentSource.filter(documentSourceId),
    q.vendorToolkit.documentSources.filter(),
    q.vendorToolkit.documents.filter(),
  ]);
  return res;
}

export async function sync(documentSourceId: DocumentSourceId) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/document_sources/{document_source_id}/sync`,
    {path: {document_source_id: documentSourceId}},
  );
  await invalidateQueries([
    q.vendorToolkit.documentSource.filter(documentSourceId),
    q.vendorToolkit.documentSources.filter(),
  ]);
  return res;
}

export async function update(documentSourceId: DocumentSourceId, update: UpdateDocumentSource) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/document_sources/{document_source_id}`,
    {body: update, path: {document_source_id: documentSourceId}},
  );
  await invalidateQueries([
    q.vendorToolkit.documentSource.filter(documentSourceId),
    q.vendorToolkit.documentSources.filter(),
  ]);
  return res;
}
